import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-head-set-disc',
  templateUrl: './order-head-set-disc.component.html',
  styleUrls: ['./order-head-set-disc.component.css']
})
export class OrderHeadSetDiscComponent implements OnInit {
    orderInternalNo;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadEdit() {
        if (!!this.orderInternalNo) {
            this.edit = (await this.datatask.Post(1604, { order_internal_no: this.orderInternalNo }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1605, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    webpage_heading: string;
    order_internal_no: string;
    prod_id: string;
    new_discount: string;
    set_new_price: string;
    new_price: string;
}
